/**
 * Endpoints du domaine fundraising (cagnottes) — source canonique.
 * `@/core/api/endpoints` ré-exporte ces valeurs : ajouter les routes ICI.
 *
 * Phase 9 — pas de service dédié (guide §6.3) : une cagnotte est portée par
 * les types de transaction `POT_CONTRIBUTION` / `POT_WITHDRAWAL` du
 * wallet-service. Les appels passent par `endpoints.wallet.transactions.*`
 * et `endpoints.feeEngine.feeQuotes.*` du registre `@/core/api/endpoints` ;
 * ce registre reste vide tant qu'aucun endpoint propre aux cagnottes
 * n'existe dans la collection Postman.
 */
export const fundraisingEndpoints = {} as const;
